import { defineMessages } from 'react-intl';

var messages = defineMessages({
  opensInNewTab: {
    id: "neptune.Link.opensInNewTab"
  }
});

export { messages as default };
//# sourceMappingURL=Link.messages.mjs.map
